export enum AuthState {
  UseAuth = 0,
  True = 1,
  False = 2,
}
